module.exports = __webpack_public_path__ + "assets/img/enterIcon5.5ffd6e7c.png";